import { Card, ConfigProvider, Tag, Typography, Col, Row } from 'antd';
import { FC } from 'react';
import { SelectableListDataType } from './selectable-list';
import { useTheme } from '../theme-context';

const ContentHeight = '100%';
interface SelectableListItemProps {
  data: SelectableListDataType;
  isVerticalColumn?: boolean;
}


export const SelectableListItem: FC<SelectableListItemProps> = (props) => {
  const { isDarkMode } = useTheme();
  return props.isVerticalColumn ? (
    <Row style={{ width: '100%', cursor: 'pointer' }}>
      <Col span={7} style={{ display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            height: ContentHeight,
            width: ContentHeight,
            border: '1px solid black',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Typography.Text>{props?.data?.initials?.toUpperCase()}</Typography.Text>
        </div>
      </Col>

      <Col span={17}>
        <div
          style={{
            height: '100%',
            marginLeft: '10px'
          }}
        >
        <Typography.Text
          style={{
            wordBreak: "break-word",
            whiteSpace: "normal",
            marginBottom: 0,
            paddingRight: "10px",
          }}
          ellipsis strong
        >
          {props.data?.title}
        </Typography.Text>
          <br />
          <Typography.Text>{props.data?.timestamp}</Typography.Text>          <br />
          <Tag style={{ border: '1px solid black' }}>{props.data?.progress}</Tag>
        </div>
      </Col>
    </Row>
  ) : (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            colorBgContainer: isDarkMode ? '#5b5a5c' : '#EBEAEF'
          }
        }
      }}
    >
      <Card
        bordered={true}
        style={{
          width: '100%',
          height: '100%',
          border: '1px solid black'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            margin: '-10px -10px -15px'
          }}
        >
          <Typography.Text style={{ fontSize: '10px', textAlign: 'left', marginLeft: "-5px" }}>{props.data?.caseType}</Typography.Text>

          <Typography.Text
            strong
            style={{
              fontSize: '10px',
              textAlign: 'center',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {props.data?.title}
          </Typography.Text>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Tag
              style={{
                border: '1px solid black',
                fontSize: '10px',
                padding: '2px 8px'
              }}
            >
              {props.data?.progress}
            </Tag>
          </div>

          <div style={{marginLeft: "-5px"}}>
            <Typography.Text style={{ fontSize: '8px', fontFamily: 'Roboto', display: 'block' }}>Date Created:</Typography.Text>
            <Typography.Text style={{ fontSize: '10px', display: 'block' }}>{props.data?.timestamp}</Typography.Text>
          </div>
        </div>
      </Card>
    </ConfigProvider>
  );
};
